import { FormFieldV2 as FormField, SearchFieldV2 as SearchField } from '@/components/custom/erp';
import { phuongThucThanhToanSearchColumns, QUERY_KEYS } from '@/constants';
import { FormFieldActions, FormFieldState } from '../../../hooks';
import { PhuongThucThanhToan } from '@/types/schemas';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface Props {
  formMode: FormMode;
  formState: {
    state: FormFieldState;
    actions: FormFieldActions;
  };
}

export const PaymentInfoTab = ({ formMode, formState: { state, actions } }: Props) => {
  return (
    <div className='flex flex-col gap-3 p-4'>
      <div className='flex items-center gap-2'>
        <Label className='w-[150px]'>Theo dõi thanh toán</Label>
        <FormField
          className='grid grid-cols-[200px,1fr] items-center'
          name='hd_yn'
          type='checkbox'
          disabled={formMode === 'view'}
        />
      </div>

      <div className='flex items-center gap-2'>
        <Label className='w-[150px]'>Số chứng từ</Label>
        <FormField type='text' name='so_ct0' disabled={formMode === 'view'} />
      </div>

      <div className='flex items-center gap-2'>
        <Label className='w-[150px]'>Ngày chứng từ</Label>
        <FormField type='date' name='ngay_ct0' disabled={formMode === 'view'} />
      </div>

      <div className='flex items-center gap-2'>
        <Label className='w-[150px]'>Mã thanh toán</Label>
        <SearchField<PhuongThucThanhToan>
          searchEndpoint={`/${QUERY_KEYS.PHUONG_THUC_THANH_TOAN}`}
          searchColumns={phuongThucThanhToanSearchColumns}
          dialogTitle='Danh mục thanh toán'
          value={state.thanhToan?.ma_pttt || ''}
          relatedFieldValue={state.thanhToan?.ten_pttt || ''}
          onRowSelection={actions.setThanhToan}
          disabled={formMode === 'view'}
        />
      </div>
    </div>
  );
};
